module.exports = __webpack_public_path__ + "img/Logo-22.32e84228.svg";